import React, {PropTypes} from 'react';

const EmptyLabel = ({
	index,
	onSelected
}) => {
	return (
		<div className="empty-label" onClick={() => {onSelected(index);}} />
	);
};

EmptyLabel.propTypes = {
	index: PropTypes.number.isRequired,
	onSelected: PropTypes.func.isRequired
};

export default EmptyLabel;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/EmptyLabel.js
 **/